
import '@/mixins/extendedComponent'

import { webGL } from '@/webGL/WebGL'

// import gsap from 'gsap'

// gsap.ticker.remove(gsap.updateRoot)

export default {

  created () {
    window.addEventListener('resize', this._onResize)
    window.addEventListener('scroll', this._onScroll)
    window.addEventListener('keydown', this._onKeyDown)

    this.$device._onResize()
    this.$hub.emit('resize', event)
  },

  mounted () {
    webGL.baseEl = this.$refs.baseContainerWebGL
    webGL.objectEl = this.$refs.objectContainerWebGL
    this.$dom3d.attachTo(this.$refs.containerCSS3D)
    this.$dom3d.setCamera(webGL.camera)
  },

  methods: {
    _onUpdate ({delta, elapsed}) {
      // gsap.updateRoot(elapsed * .001)
      this.$dom3d.update()
    },
    _onResize (event) {
      webGL.resize({ width: this.$device.width, height: this.$device.height })
      this.$dom3d.onResize(this.$device.width, this.$device.height)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$device._onResize()
        this.$hub.emit('resize', event)
      }, 200)
    },
    _onScroll (event) {
      this.$device._onScroll()
      this.$hub.emit('scroll', event)
    },
    _onKeyDown (event) {
      this.$hub.emit('keydown', event.keyCode)
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        this.$hub.emit('keydown:escape', event.keyCode)
      }
    }
  }
}
